import {GetFilmIdResultType, LocalReducerEventProps, LocalReducerState, UpdateMovieType} from "./reducer.types";
import Network from "../../../support/network";
import {getFilmsImdbFilmaRequest} from "../../../support/network/requests/google_search";
import {postPendingFilm} from "../../../support/network/requests/pending_films";

const SET_LIST = 'SET_LIST';
const NEXT_ROW = 'NEXT_ROW';
const DELETE_CURRENT = 'DELETE_CURRENT';
const SET_FILM_RESULT = 'SET_FILM_RESULT';

const enLiterals = ['eng']
const esLiterals = ['spa']

export const dispatchToProps = (dispatch: React.Dispatch<any>): LocalReducerEventProps => ({
    setList: (listStr: string) =>
        dispatch({
            type: SET_LIST,
            listStr,
        }),
    nextRow: () =>
        dispatch({
            type: NEXT_ROW,
        }),
    deleteCurrent: () =>
        dispatch({
            type: DELETE_CURRENT,
        }),
    setGetFilmIdResult: (result: GetFilmIdResultType) =>
        dispatch({
            type: SET_FILM_RESULT,
            result
        }),
});

export const initState: LocalReducerState = {
    list: [],
    currentIndex: 0,
    currentRow: {},
    getFilmIdResult: {filmaffinity: [], imdb: []}
};

function convertList(listStr: string): string[] {
    const hhh = /[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\t[^\t]*\n/g
    let out: string[] = []
    const matches = (listStr as string).matchAll(hhh);
    for (const match of matches) {
        out = [...out, match[0]]
        processRow(match[0])
    }
    return out
}

function processRow(rowStr: string): UpdateMovieType {
    const audioRegExp = /Stream #\d:\d\(?(?<tag>[^\(\)\:]*)\)?: Audio.*(\n.*Metadata:.*(\n.*title.*:(?<title>.*))?(\n.*LANGUAGE.*:(?<lang>.*))?)?/g
    const subsRegExp = /Stream #\d:\d\(?(?<tag>[^\(\)\:]*)\)?: Subtitle.*(\n.*Metadata:.*(\n.*title.*:(?<title>.*))?(\n.*LANGUAGE.*:(?<lang>.*))?)?/g

    const ddd = rowStr.split('\t')
    // const filename = `${ddd[3]}/${ddd[1]}.${ddd[4]}`
    const langs: string[] = []
    const subs: string[] = ddd[6] ? ddd[6].split(',') : []
    const info = ddd[8]
    const audiosMatch = info.matchAll(audioRegExp);
    let audioCount = 0
    for (const a of audiosMatch) {
        audioCount = audioCount + 1
        let l = (a?.groups?.lang?.trim() === 'und' ? undefined : a?.groups?.lang?.trim()) || (a?.groups?.tag?.trim() === 'und' ? undefined : a?.groups?.tag?.trim()) || a?.groups?.title?.trim()
        enLiterals.forEach(it => l = l?.replace(it, 'en'))
        esLiterals.forEach(it => l = l?.replace(it, 'es'))
        if (l && !langs.includes(l)) {
            langs.push(l)
        }
    }
    const subsMatch = info.matchAll(subsRegExp);
    let subsCount = 0
    for (const s of subsMatch) {
        subsCount = subsCount + 1
        let l = (s?.groups?.lang?.trim() === 'und' ? undefined : s?.groups?.lang?.trim()) || (s?.groups?.tag?.trim() === 'und' ? undefined : s?.groups?.tag?.trim()) || s?.groups?.title?.trim()
        enLiterals.forEach(it => l = l?.replace(it, 'en'))
        esLiterals.forEach(it => l = l?.replace(it, 'es'))
        if (l && !subs.includes(l)) {
            subs.push(l)
        }
    }

    console.log(ddd)

    Network.instance.netClient.executeRequest(postPendingFilm({
        title: ddd[0],
        filename: ddd[1],
        year: ddd[2],
        folder: ddd[3],
        extension: ddd[4],
        size_mb: ddd[5] ? parseInt(ddd[5]) : undefined,
        md5: ddd[7],
        file_data: ddd[8],
        langs: langs.length > 0 ? langs.join(',') : audioCount.toString(),
        subs: subs.length > 0 ? subs.join(',') : subsCount.toString(),
    }))

    return {
        name: ddd[0],
        fileName: ddd[1],
        year: ddd[2],
        folder: ddd[3],
        ext: ddd[4],
        size: ddd[5] ? parseInt(ddd[5]) : undefined,
        md5: ddd[7],
        fileInfo: ddd[8],
        subs: subs.length > 0 ? subs.join(',') : subsCount.toString(), // (ddd[6])
        audio: langs.length > 0 ? langs.join(',') : audioCount.toString(),
    }
}

export const component_reducer = (state: LocalReducerState = initState, action: any) => {
    switch (action.type) {
        case SET_LIST: {
            const list = convertList(action.listStr)
            console.log('processRow(list[state.currentIndex])')
            console.log(processRow(list[state.currentIndex]))
            return {...initState,
                list: list,
                currentRow: processRow(list[state.currentIndex]),
                getFilmIdResult: initState.getFilmIdResult
            };
            return state
        }
        case NEXT_ROW: {
            return {...state,
                currentIndex: state.currentIndex + 1,
                currentRow: processRow(state.list[state.currentIndex]),
                getFilmIdResult: initState.getFilmIdResult
            };
        }
        case DELETE_CURRENT: {
            const l = [...state.list.slice(0, state.currentIndex), ...state.list.slice(state.currentIndex + 1)]
            return {
                ...state,
                list: l,
                currentIndex: state.currentIndex,
                currentRow: processRow(l[state.currentIndex]),
                getFilmIdResult: initState.getFilmIdResult
            };
        }
        case SET_FILM_RESULT:
            return {
                ...state,
                currentRow: {
                    ...state.currentRow,
                    imdbResult: action.result.imdb?.length > 0 ? action.result.imdb[0] : '',
                    filmaffinityResult: action.result.filmaffinity?.length > 0 ? action.result.filmaffinity[0] : ''
                }
            };
        default:
            return state;
    }
};
